import _ from 'lodash';
import config from './default';

const qa = _.cloneDeep(config);

export default qa;
